import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/don-tu/nghi-phep'

// Lấy số ngày nghỉ phép
export function laySoNgayNghiPhep() {
  try {
    return axiosApi.get(`${BASE}/so-ngay-phep-con-lai`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo đơn nghỉ phép
export function taoDonNghiPhep(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-don-nghi-phep`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch sử nghỉ phép
export function layLichSuNghiPhep(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/lich-su-nghi-phep`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết đơn nghỉ phép
export function layChiTietDonNghiPhep(leaveId: number) {
  try {
    return axiosApi.get(`${BASE}/chi-tiet/${leaveId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách đơn nghỉ phép chờ duyệt
export function layDanhSachDonNghiPhepChoDuyet(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/don-cho-duyet`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Phê duyệt đơn nghỉ phép
export function pheDuyetDonNghiPhep(leaveId: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/duyet-don`, {
      idDonNghiPhep: leaveId,
      ...params,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Từ chối đơn nghỉ phép
export function tuChoiDonNghiPhep(leaveId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tu-choi-don`, {
      idDonNghiPhep: leaveId,
      ...params,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
